export const environment = {
  production: true,
  env: 'prod',
  default_schema: '',
  version: 'v1.4.12',
  baseURL: 'https://jecrm.org/api',
  socketURL: 'https://jecrm.org/api/ws',
  web_url: 'jecrm.org',
  login_url: 'https://auth.jecrm.org/login',
  registration_url: 'https://auth.jecrm.org/register',
  levelSubdomain: 2,
  specialDomains: [
    'dev',
    'demo',
    'api',
    'dev-api',
    'demo-api',
    'sso',
    'dev-sso',
    'demo-sso',
    'tb',
    'dev-tb',
    'demo-tb',
  ],
};
